import styled from 'styled-components';

import { getTypographyFontColor } from './helpers';

const Headline06 = styled.h6`
    font-family: ${ ({ theme }) => theme.type.titleFont };
    color: ${ getTypographyFontColor };
    font-size: 1.25rem;
    font-weight: 600;
    letter-spacing: 0.05px;
    line-height: 32px;
    margin: 0;
`;

export default Headline06;
